import { BarLoader } from "react-spinners";
import React, { PureComponent } from "react";
import connect from "react-redux/es/connect/connect";

class MPSBarLoader extends PureComponent {
  render() {
    let { appTheme = {}, width = 100, widthUnit = "px" } = this.props;
    let themeColor = appTheme.themeColor
      ? appTheme.themeColor.replace("0x", "#")
      : "#20a8d8";

    return <BarLoader color={themeColor} width={width} widthUnit={widthUnit} />;
  }
}

const mapstatetoprops = state => ({
  appTheme: state.user.data ? state.user.data.appTheme : {}
});

export default connect(mapstatetoprops)(MPSBarLoader);
